import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const KakaoCallbackElectron = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    window.location.href = `hemochat://get-token?token=${temp_token}&host=kakao`;
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      navigate('/upload');
    } else {
      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  const temp_token = new URL(window.location.href).searchParams.get(
    'temp_token'
  );

  return (
    <div
      style={{
        backgroundColor: 'white',
        width: '100vw',
        height: '100vh',
      }}
    >
      {timeLeft}초 뒤에 자동으로 메인페이지로 이동합니다.
    </div>
  );
};
export default KakaoCallbackElectron;
